interface SpinnerIconProps {
  className?: string;
}

export const SpinnerIcon = ({ className = '' }: SpinnerIconProps) => {
  return (
    <div className={`relative w-5 h-5 ${className}`} role="progressbar" aria-label="読み込み中" aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} tabIndex={0}>
      <div className="absolute w-full h-full border-2 border-gray-200 rounded-full" />
      <div className="absolute w-full h-full border-2 border-t-primary rounded-full animate-[spin_0.6s_linear_infinite]" />
    </div>
  );
};
